__turbopack_context__.v({
  "icon": "KnwTSq_icon",
});
